import styled from 'styled-components'
import { COLOURS } from 'resources'

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns || 2}, 1fr);
  gap: 5px;
  background-color: ${COLOURS.neutralWhite};
`

export const SpinnerContainer = styled.div`
  width: 100%;
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`
